var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    class: _vm.classObj
  }, _vm._l((_vm.renderData), function(r, index) {
    return _c('li', {
      class: _vm.liclassObj(index, r),
      attrs: {
        "disabled": r.disabled
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.handleTabListClick(index, r)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n          " + _vm._s(r.header) + "\n          "), (r.badge) ? _c('n3-badge', [_vm._v(_vm._s(r.badge))]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('div', {
    class: (_vm.prefixCls + "-tab-content")
  }, [(_vm.list) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderData[_vm.activeIndex].content)
    }
  })]) : _vm._t("default")], 2)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6bc9cfcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc9cfcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tabs/n3Tabs.vue
// module id = 637
// module chunks = 0 1